import {Component, EventEmitter, Output} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {CaretRightIconComponent} from '../../svg/caret-right-icon/caret-right-icon.component';
import {CaretDownIconComponent} from '../../svg/caret-down-icon/caret-down-icon.component';
import {NgIf} from '@angular/common';

interface SearchFor {
  includeProductName: boolean;
  includeOrderNumber: boolean;
  includeOrgId: boolean;
}

export interface OrderSearchCriteria {
  query: string;
  searchFor: SearchFor;
  beginDate: string;
  endDate: string;
}

@Component({
  selector: 'app-order-search',
  templateUrl: './order-search.component.html',
  styleUrls: ['./order-search.component.scss'],
  standalone: true,
  imports: [
    CaretRightIconComponent,
    CaretDownIconComponent,
    ReactiveFormsModule,
    NgIf
  ]
})
export class OrderSearchComponent {

  @Output()
  searchEvent = new EventEmitter<OrderSearchCriteria | undefined>();

  searchVisible = false;

  searchForm: UntypedFormGroup = this.fb.group({
    query: this.fb.control(''),

    includeProductName: this.fb.control(true),
    includeOrderNumber: this.fb.control(true),
    includeOrgId: this.fb.control(true),

    beginDate: this.fb.control(''),
    endDate: this.fb.control(''),
  });

  constructor(private readonly fb: UntypedFormBuilder) {
  }

  showSearch(): void {
    this.searchVisible = true;
  }

  hideSearch(): void {
    this.searchVisible = false;
    this.searchEvent.emit(undefined);
  }

  submit(): void {
    this.searchEvent.emit({
      query: this.searchForm.controls.query.value,
      searchFor: {
        includeProductName: this.searchForm.controls.includeProductName.value,
        includeOrderNumber: this.searchForm.controls.includeOrderNumber.value,
        includeOrgId: this.searchForm.controls.includeOrgId.value,
      },
      beginDate: this.searchForm.controls.beginDate.value,
      endDate: this.searchForm.controls.endDate.value,
    });
  }

}
